
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diseases/[encodedName]",
      function () {
        return require("private-next-pages/diseases/[encodedName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diseases/[encodedName]"])
      });
    }
  